import React from 'react';
import styled from 'styled-components';
import CourseKLineSelector, { ICourseKLineConfig } from '../../../../components/CourseKLineSelector';
import RefSelectorList, { IRefOption } from '../../../../components/RefSelectorList';
import DialectSelect, { IDialectOption } from 'components/selects/DialectSelect';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { TRANSLATION_REF_OPTIONS } from '../../constants/translationRefOptions';

type Props = {
  title?: string;
  valueCourses: ICourseKLineConfig[];
  onCoursesChange: (courses: ICourseKLineConfig[]) => void;
  valueOnlyPublished?: boolean;
  onOnlyPublishedChange?: (checked: boolean) => void;
  showDialect?: boolean;
  dialectId?: number;
  onDialectChange?: (dialectId: number) => void;
  showRefs?: boolean;
  valueRefs?: number[];
  onRefsChange?: (refs: number[]) => void;
  refOptions?: IRefOption[];
};

const MemoryTranslationFilter: React.FC<Props> = ({
  title = 'Course and KLine Selection',
  valueCourses,
  onCoursesChange,
  valueOnlyPublished = false,
  onOnlyPublishedChange,
  showDialect = false,
  dialectId = 0,
  onDialectChange,
  showRefs = false,
  valueRefs = [],
  onRefsChange,
  refOptions = TRANSLATION_REF_OPTIONS,
}) => {
  const handleDialectChange = (opt: IDialectOption) => {
    onDialectChange && onDialectChange(opt.dialectId);
  };

  return (
    <Wrapper>
      <HeaderRow>
        <SectionTitle>{title}</SectionTitle>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={!!valueOnlyPublished}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => onOnlyPublishedChange && onOnlyPublishedChange(!!e.target.checked)}
            />
          }
          label="Limit to published lessons"
        />
      </HeaderRow>

      <CourseKLineSelector value={valueCourses} onChange={onCoursesChange} />

      {(showDialect || showRefs) && (
        <TwoColumnGrid>
          {showDialect ? (
            <Column>
              <SubTitle>Dialect</SubTitle>
              <DialectSelect onlySource handleDialectChange={handleDialectChange} />
            </Column>
          ) : (
            <Column />
          )}
          {showRefs ? (
            <Column>
              <SubTitle>Translation Sources</SubTitle>
              <RefSelectorList value={valueRefs} onChange={onRefsChange || (() => {})} options={refOptions} />
            </Column>
          ) : (
            <Column />
          )}
        </TwoColumnGrid>
      )}
    </Wrapper>
  );
};

export default MemoryTranslationFilter;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
  margin-top: 8px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SectionTitle = styled(Typography).attrs({ variant: 'h6' })``;
const SubTitle = styled(Typography).attrs({ variant: 'subtitle1' })``;
